import script from "./psiShopPankuOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./psiShopPankuOrder.vue?vue&type=script&setup=true&lang=js"

import "./psiShopPankuOrder.vue?vue&type=style&index=0&id=43b00429&scoped=true&lang=css"

import exportComponent from "E:\\zanbiya\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b00429"]])

export default __exports__